<template>
    <div>
        <form @submit.prevent="formSubmit">
            <div class="form-row">
                <div class="form-group col-md-4">
                    <label for="category">{{ $t('omsz-form.labels.category') }} <span
                        class="text-danger">*</span></label>
                    <multiselect id="category"
                                 v-model="category"
                                 label="name"
                                 track-by="name"
                                 :placeholder="$t('omsz-form.placeholders.select')"
                                 :select-label="$t('omsz-form.placeholders.select_enter')"
                                 :selected-label="$t('omsz-form.placeholders.selected')"
                                 :deselect-label="$t('omsz-form.placeholders.remove')"
                                 :options="categories"
                                 :allow-empty="false"
								 @select="selectCategory">
                        <template slot="component_area" slot-scope="{ option }">{{ option.name }}</template>
                        <template slot="noResult">{{ $t('omsz-form.errors.not_found') }}</template>
                    </multiselect>
                </div>
                <div class="form-group col-md-4">
                    <label for="component">{{ $t('omsz-form.labels.pollutants') }} <span
                        class="text-danger">*</span></label>
                    <multiselect id="component"
                                 v-model="component"
                                 label="name"
                                 track-by="name"
                                 :placeholder="$t('omsz-form.placeholders.select')"
                                 :select-label="$t('omsz-form.placeholders.select_enter')"
                                 :selected-label="$t('omsz-form.placeholders.selected')"
                                 :deselect-label="$t('omsz-form.placeholders.remove')"
                                 :options="filters.component"
                                 :allow-empty="false"
								 :disabled="isDisabledComponent"
                                 @select="selectComponent">
                        <template slot="component_area" slot-scope="{ option }">{{ option.name }}</template>
                        <template slot="noResult">{{ $t('omsz-form.errors.not_found') }}</template>
                    </multiselect>
                </div>
                <div class="form-group col-md-4">
                    <label for="year">{{ $t('omsz-form.labels.date.year') }} <span
                        class="text-danger">*</span></label>
                    <multiselect id="year"
                                 v-model="year"
                                 label="name"
                                 track-by="name"
                                 :placeholder="$t('omsz-form.placeholders.select')"
                                 :select-label="$t('omsz-form.placeholders.select_enter')"
                                 :selected-label="$t('omsz-form.placeholders.selected')"
                                 :deselect-label="$t('omsz-form.placeholders.remove')"
                                 :options="filters.year"
                                 :allow-empty="false"
                                 :disabled="isDisabledYear">
                        <template slot="component_area" slot-scope="{ option }">{{ option.name }}</template>
                        <template slot="noResult">{{ $t('omsz-form.errors.not_found') }}</template>
                    </multiselect>
                </div>
            </div>
            <div class="form-row justify-content-end">
                <div class="buttons d-flex align-items-center">
                    <div class="btn btn-link text-uppercase mr-3" @click="clearAll" :class="{'disabled': !(component && year) || isLoading}">{{$t('omsz.buttons.clear_filters')}}</div>
                    <button class="btn btn-primary" :class="{'loader': isLoading}" type="submit" :disabled="!(component && year) || isLoading">
                        <span>{{$t('omsz.buttons.start_query')}}</span>
                        <i class="icon icon-arrow-right"></i>
                    </button>
                </div>
            </div>
        </form>
        <div class="row" v-if="errorMessage">
            <div class="col-auto">
                {{errorMessage}}
            </div>
        </div>
        <div class="mt-5" v-if="chartData">
            <component :is="chartType" :chart-data="chartData" :options="chartOptions"/>
        </div>
    </div>
</template>
<script>
import Multiselect from 'vue-multiselect';
import axios from 'axios';
import LineChart from '../components/LineChart';
import Bar from '../components/Bar';
import Doughnut from '../components/Doughnut';

export default {
    name: 'interactive-charts',
    components: {
        Multiselect,
        LineChart,
        Bar,
        Doughnut,
    },
    props: {
        categories: {
            type: Array,
            required: true,
        },
        components: {
            type: Array,
            required: true,
        },
        years: {
            type: Array,
            required: true,
        },
    },
    data() {
      return {
          filters: {
              component: this.components,
              year: this.years
          },
          category: null,
          component: null,
          year: null,
          isLoading: false,
          isDisabledComponent: true,
          isDisabledYear: true,
          errorMessage: null,
          chartType: '',
		  chartID: null,
          chartData: null,
          chartOptions: null,
      }
    },
    methods: {
        clearAll(e) {
            this.category = null;
            this.component = null;
            this.year = null;
        },
		async selectCategory(e) {
			this.isDisabledComponent = false;
			this.component = null;
			this.year = null;

			// refresh components
			let response = await axios.post('/api/emissions/interactive-chart-components',{
				categoryID : e.value,
			},
			{
				headers: {'Accept-Language': window.Met.locale },
			})
			this.filters.component = response.data
		},
        async selectComponent(e) {
            this.isDisabledYear = false;
            this.year = null;
            this.filters.year = e.years;
			let response = await axios.post('/api/emissions/interactive-chart-years',{
				categoryID : this.category.value,
				componentID : e.value,
			},
			{
				headers: {'Accept-Language': window.Met.locale },
			})
			
			this.filters.year = response.data
			
        },
        async formSubmit() {
            if (this.isLoading) {
                return;
            }

            this.isLoading = true;
            this.chartData = null;
            this.errorMessage = null;
			

			switch(this.year.type){
				case 'bar': this.chartID=1; break;	// oszlopdiagram
				case 'doughnut': this.chartID=2; break;	// kordiagram
				default: this.chartID=3;	// vonaldiagram
			}
			if(this.year.value >10 && this.year.value<14){  // orszagos - osszes - % vonaldiagram de kulon lekerdezes kell neki
				this.chartID = 4;
			}

            const allParams = {
				// TODO graphid
                category: this.category.value, // parentcatid
                component: this.component.value, // poll_lstid
				//pollid: this.component.component, // pollid
                year: this.year.start, // dat
				chartID: this.chartID, // chart id
				dateid: this.year.value // dateid
            }


			

            try {
                const response = await axios.post(`/api/emissions/interactive-chart?`,  allParams,{
                    headers: { 'Accept-Language': window.Met.locale },
                })
                this.chartType = response.data.chartType;
                this.chartData = response.data;
                this.chartOptions = response.data.chartOptions;
            }
            catch(error) {
                this.errorMessage = error.response.data;
            }
            finally {
                this.isLoading = false;
            }
        }
    }
}
</script>
